export default __webpack_public_path__ + "static/media/iphone-login-6.5.6c6e69e1.jpg";